<template>
  <div>
    <div class="columns is-multiline is-mobile">
      <div class="column is-full">
        <window :showHeader="false">
          <p>Find documentation
            <a href="https://github.com/weizhenye/vue-highcharts" target="_blank">here</a> and
            <a href="https://www.highcharts.com/demo" target="_blank">here</a> and
            <a href="https://www.npmjs.com/package/vue-highcharts" target="_blank">here</a>.</p>
          <p>An example
            <a href="https://codepen.io/weizhenye/pen/rrKgbP">here</a>.</p>
        </window>
      </div>
      <div class="column is-full">
        <window title="Line chart #1">
          <highcharts :options="optionsLine" ref="highcharts"></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Line chart #2">
          <highcharts :options="optionsLine2" ref="highcharts"></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Multiple series line chart">
          <highcharts :options="optionsMultipleLine" ref="highcharts"></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Spline chart">
          <highcharts :options="optionsSpline" ref="highcharts"></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Bar chart">
          <highcharts :options="optionsBar" ref="highcharts"></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Navigate bar chart">
          <highcharts :options="optionsNegativeBar" ref="highcharts"></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Column chart">
          <highcharts :options="optionsColumn" ref="highcharts"></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Stacked and grouped column chart">
          <highcharts :options='optionsColumnStackedGrouped' ref='highcharts'></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Pie chart">
          <highcharts :options="optionsPie" ref="highcharts"></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Donut chart">
          <highcharts :options="optionsDonut" ref="highcharts"></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Semi donut chart">
          <highcharts :options='optionsSemiDonut' ref='highcharts'></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Area chart">
          <highcharts :options="optionsArea" ref="highcharts"></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Percentage area chart">
          <highcharts :options="optionsPercentageArea" ref="highcharts"></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="BoxPlot chart">
          <highcharts :options="optionsBoxPlot" ref="highcharts"></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Polygon series chart">
          <highcharts :options="optionsPolygonSeries" ref="highcharts"></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="General drawing chart">
          <highcharts :options="optionsGeneralDrawing" ref="highcharts"></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Dynamic add point chart">
          <highcharts :options="optionsAddPoint" ref="highcharts"></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Combination 1 (Column, line and pie)">
          <highcharts :options='optionsCombination1' ref='highcharts'></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Combination 2 (Dual axes, line and column)">
          <highcharts :options='optionsCombination2' ref='highcharts'></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Combination 3 (Multiple axes, line and column)">
          <highcharts :options='optionsCombination3' ref='highcharts'></highcharts>
        </window>
      </div>
      <div class="column is-full">
        <window title="Combination 4 (Scatter with regression line)">
          <highcharts :options='optionsCombination4' ref='highcharts'></highcharts>
        </window>
      </div>
    </div>
  </div>
</template>


<script>

import Vue from 'vue';
import VueHighCharts from 'vue-highcharts';
import Highcharts from 'highcharts';
import loadHighchartsMore from 'highcharts/highcharts-more';

loadHighchartsMore(Highcharts);

Vue.use(VueHighCharts, { Highcharts });

export default {
  components: {
    VueHighCharts,
  },

  data() {
    return {
      optionsLine: {
        title: {
          text: 'Monthly Average Temperature',
          x: -20, // center
        },
        subtitle: {
          text: 'Source: WorldClimate.com',
          x: -20,
        },
        xAxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
          ],
        },
        yAxis: {
          title: {
            text: 'Temperature (°C)',
          },
          plotLines: [{
            value: 0,
            width: 1,
            color: '#808080',
          }],
        },
        tooltip: {
          valueSuffix: '°C',
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          borderWidth: 0,
        },
        series: [{
          name: 'Tokyo',
          data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6],
        }],
      },
      optionsLine2: {
        chart: {
          type: 'line',
        },
        title: {
          text: 'Monthly Average Temperature',
        },
        subtitle: {
          text: 'Source: WorldClimate.com',
        },
        xAxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        },
        yAxis: {
          title: {
            text: 'Temperature (°C)',
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
            },
            enableMouseTracking: false,
          },
        },
        series: [{
          name: 'Tokyo',
          data: [7.0, 6.9, 9.5, 14.5, 18.4, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6],
        }, {
          name: 'London',
          data: [3.9, 4.2, 5.7, 8.5, 11.9, 15.2, 17.0, 16.6, 14.2, 10.3, 6.6, 4.8],
        }],
      },
      optionsMultipleLine: {
        title: {
          text: 'Monthly Average Temperature',
          x: -20, // center
        },
        subtitle: {
          text: 'Source: WorldClimate.com',
          x: -20,
        },
        xAxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
          ],
        },
        yAxis: {
          title: {
            text: 'Temperature (°C)',
          },
          plotLines: [{
            value: 0,
            width: 1,
            color: '#808080',
          }],
        },
        tooltip: {
          valueSuffix: '°C',
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          borderWidth: 0,
        },
        series: [{
          name: 'Tokyo',
          data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6],
        }, {
          name: 'New York',
          data: [-0.2, 0.8, 5.7, 11.3, 17.0, 22.0, 24.8, 24.1, 20.1, 14.1, 8.6, 2.5],
        }, {
          name: 'Berlin',
          data: [-0.9, 0.6, 3.5, 8.4, 13.5, 17.0, 18.6, 17.9, 14.3, 9.0, 3.9, 1.0],
        }, {
          name: 'London',
          data: [3.9, 4.2, 5.7, 8.5, 11.9, 15.2, 17.0, 16.6, 14.2, 10.3, 6.6, 4.8],
        }],
      },
      optionsBar: {
        chart: {
          type: 'bar',
        },
        title: {
          text: 'Monthly Average Temperature',
        },
        subtitle: {
          text: 'Source: WorldClimate.com',
        },
        xAxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        },
        yAxis: {
          title: {
            text: 'Temperature (°C)',
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
            },
            enableMouseTracking: false,
          },
        },
        series: [{
          name: 'Tokyo',
          data: [7.0, 6.9, 9.5, 14.5, 18.4, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6],
        }, {
          name: 'London',
          data: [3.9, 4.2, 5.7, 8.5, 11.9, 15.2, 17.0, 16.6, 14.2, 10.3, 6.6, 4.8],
        }],
      },
      optionsNegativeBar: {
        chart: {
          type: 'bar',
        },
        title: {
          text: 'Population pyramid for Germany, 2018',
        },
        subtitle: {
          text: 'Source: <a href="http://populationpyramid.net/germany/2018/">Population Pyramids of the World from 1950 to 2100</a>',
        },
        xAxis: [{
          categories:
          [
            '0-4', '5-9', '10-14', '15-19',
            '20-24', '25-29', '30-34', '35-39', '40-44',
            '45-49', '50-54', '55-59', '60-64', '65-69',
            '70-74', '75-79', '80-84', '85-89', '90-94',
            '95-99', '100 + ',
          ],
          reversed: false,
          labels: {
            step: 1,
          },
        }, {
          // mirror axis on right side
          opposite: true,
          reversed: false,
          categories:
          [
            '0-4', '5-9', '10-14', '15-19',
            '20-24', '25-29', '30-34', '35-39', '40-44',
            '45-49', '50-54', '55-59', '60-64', '65-69',
            '70-74', '75-79', '80-84', '85-89', '90-94',
            '95-99', '100 + ',
          ],
          linkedTo: 0,
          labels: {
            step: 1,
          },
        }],
        yAxis: {
          title: {
            text: null,
          },
          labels: {
            formatter() {
              return `${Math.abs(this.value)}%`;
            },
          },
        },

        plotOptions: {
          series: {
            stacking: 'normal',
          },
        },

        tooltip: {
          formatter() {
            return `<b>${this.series.name}, age ${this.point.category}</b><br/>` +
            `Population: ${VueHighCharts.numberFormat(Math.abs(this.point.y), 0)}`;
          },
        },

        series: [{
          name: 'Male',
          data: [
            -2.2, -2.1, -2.2, -2.4,
            -2.7, -3.0, -3.3, -3.2,
            -2.9, -3.5, -4.4, -4.1,
            -3.4, -2.7, -2.3, -2.2,
            -1.6, -0.6, -0.3, -0.0,
            -0.0,
          ],
        }, {
          name: 'Female',
          data: [
            2.1, 2.0, 2.1, 2.3, 2.6,
            2.9, 3.2, 3.1, 2.9, 3.4,
            4.3, 4.0, 3.5, 2.9, 2.5,
            2.7, 2.2, 1.1, 0.6, 0.2,
            0.0,
          ],
        }],
      },
      optionsColumn: {
        chart: {
          type: 'column',
        },
        title: {
          text: 'Monthly Average Temperature',
        },
        subtitle: {
          text: 'Source: WorldClimate.com',
        },
        xAxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        },
        yAxis: {
          title: {
            text: 'Temperature (°C)',
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
            },
            enableMouseTracking: false,
          },
        },
        series: [{
          name: 'Tokyo',
          data: [7.0, 6.9, 9.5, 14.5, 18.4, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6],
          color: '#ed6c62',
        }, {
          name: 'London',
          data: [3.9, 4.2, 5.7, 8.5, 11.9, 15.2, 17.0, 16.6, 14.2, 10.3, 6.6, 4.8],
          color: '#ffdd57',
        }],
      },
      optionsSpline: {
        chart: {
          type: 'spline',
          scrollablePlotArea: {
            minWidth: 600,
            scrollPositionX: 1,
          },
        },
        title: {
          text: 'Wind speed during two days',
        },
        subtitle: {
          text: '13th & 14th of February, 2018 at two locations in Vik i Sogn, Norway',
        },
        xAxis: {
          type: 'datetime',
          labels: {
            overflow: 'justify',
          },
        },
        yAxis: {
          title: {
            text: 'Wind speed (m/s)',
          },
          minorGridLineWidth: 0,
          gridLineWidth: 0,
          alternateGridColor: null,
          plotBands: [{ // Light air
            from: 0.3,
            to: 1.5,
            color: 'rgba(68, 170, 213, 0.1)',
            label: {
              text: 'Light air',
              style: {
                color: '#606060',
              },
            },
          }, { // Light breeze
            from: 1.5,
            to: 3.3,
            color: 'rgba(0, 0, 0, 0)',
            label: {
              text: 'Light breeze',
              style: {
                color: '#606060',
              },
            },
          }, { // Gentle breeze
            from: 3.3,
            to: 5.5,
            color: 'rgba(68, 170, 213, 0.1)',
            label: {
              text: 'Gentle breeze',
              style: {
                color: '#606060',
              },
            },
          }, { // Moderate breeze
            from: 5.5,
            to: 8,
            color: 'rgba(0, 0, 0, 0)',
            label: {
              text: 'Moderate breeze',
              style: {
                color: '#606060',
              },
            },
          }, { // Fresh breeze
            from: 8,
            to: 11,
            color: 'rgba(68, 170, 213, 0.1)',
            label: {
              text: 'Fresh breeze',
              style: {
                color: '#606060',
              },
            },
          }, { // Strong breeze
            from: 11,
            to: 14,
            color: 'rgba(0, 0, 0, 0)',
            label: {
              text: 'Strong breeze',
              style: {
                color: '#606060',
              },
            },
          }, { // High wind
            from: 14,
            to: 15,
            color: 'rgba(68, 170, 213, 0.1)',
            label: {
              text: 'High wind',
              style: {
                color: '#606060',
              },
            },
          }],
        },
        tooltip: {
          valueSuffix: ' m/s',
        },
        plotOptions: {
          spline: {
            lineWidth: 4,
            states: {
              hover: {
                lineWidth: 5,
              },
            },
            marker: {
              enabled: false,
            },
            pointInterval: 3600000, // one hour
            pointStart: Date.UTC(2018, 1, 13, 0, 0, 0),
          },
        },
        series: [{
          name: 'Hestavollane',
          data: [
            3.7, 3.3, 3.9, 5.1, 3.5, 3.8, 4.0, 5.0, 6.1, 3.7, 3.3, 6.4,
            6.9, 6.0, 6.8, 4.4, 4.0, 3.8, 5.0, 4.9, 9.2, 9.6, 9.5, 6.3,
            9.5, 10.8, 14.0, 11.5, 10.0, 10.2, 10.3, 9.4, 8.9, 10.6, 10.5, 11.1,
            10.4, 10.7, 11.3, 10.2, 9.6, 10.2, 11.1, 10.8, 13.0, 12.5, 12.5, 11.3,
            10.1,
          ],

        }, {
          name: 'Vik',
          data: [
            0.2, 0.1, 0.1, 0.1, 0.3, 0.2, 0.3, 0.1, 0.7, 0.3, 0.2, 0.2,
            0.3, 0.1, 0.3, 0.4, 0.3, 0.2, 0.3, 0.2, 0.4, 0.0, 0.9, 0.3,
            0.7, 1.1, 1.8, 1.2, 1.4, 1.2, 0.9, 0.8, 0.9, 0.2, 0.4, 1.2,
            0.3, 2.3, 1.0, 0.7, 1.0, 0.8, 2.0, 1.2, 1.4, 3.7, 2.1, 2.0,
            1.5,
          ],
        }],
        navigation: {
          menuItemStyle: {
            fontSize: '10px',
          },
        },
      },
      optionsArea: {
        chart: {
          type: 'area',
        },
        title: {
          text: 'Some data about 2 countries',
        },
        subtitle: {
          text: 'Your subtitle here',
        },
        xAxis: {
          allowDecimals: false,
          labels: {
            formatter() {
              return this.value; // clean, unformatted number for year
            },
          },
        },
        yAxis: {
          title: {
            text: 'Nuclear weapon states',
          },
          labels: {
            formatter() {
              return `${this.value / 1000}k`;
            },
          },
        },
        tooltip: {
          pointFormat: 'Name: <b>{series.name}</b> <br/>x: <b>{point.x}</b> y:<b> {point.y:,.0f}</b>',
        },
        plotOptions: {
          area: {
            pointStart: 1940,
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: {
                hover: {
                  enabled: true,
                },
              },
            },
          },
        },
        series: [{
          name: 'First country',
          data: [
            null, null, null, null, null, 6, 11, 32, 110, 235,
            369, 640, 1005, 1436, 2063, 3057, 4618, 6444, 9822, 15468,
            20434, 24126, 27387, 29459, 31056, 31982, 32040, 31233, 29224, 27342,
            26662, 26956, 27912, 28999, 28965, 27826, 25579, 25722, 24826, 24605,
            24304, 23464, 23708, 24099, 24357, 24237, 24401, 24344, 23586, 22380,
            24304, 23464, 23708, 24099, 24357, 24237, 24401, 24344, 23586, 22380,
            24304, 23464, 23708, 24099, 24357, 24237, 24401, 24344, 23586, 22380,
            21004, 17287, 14747, 13076, 12555, 12144, 11009, 10950, 10871, 10824,
            10577, 10527, 10475, 10421, 10358, 10295, 10104, 9914, 9620, 9326,
            5113, 5113, 4954, 4804, 4761, 4717, 4368, 4018,
          ],
        }, {
          name: 'Second country',
          data: [
            null, null, null, null, null, null, null, null, null, null,
            5, 25, 50, 120, 150, 200, 426, 660, 869, 1060,
            1605, 2471, 3322, 4238, 5221, 6129, 7089, 8339, 9399, 10538,
            11643, 13092, 14478, 15915, 17385, 19055, 21205, 23044, 25393, 27935,
            30062, 32049, 33952, 35804, 37431, 39197, 45000, 43000, 41000, 39000,
            37000, 35000, 33000, 31000, 29000, 27000, 25000, 24000, 23000, 22000,
            37000, 35000, 33000, 31000, 29000, 27000, 25000, 24000, 23000, 22000,
            37000, 35000, 33000, 31000, 29000, 27000, 25000, 24000, 23000, 22000,
            21000, 20000, 19000, 18000, 18000, 17000, 16000, 15537, 14162, 12787,
            12600, 11400, 5500, 4512, 4502, 4502, 4500, 4500,
          ],
        }],
      },
      optionsPercentageArea: {
        chart: {
          type: 'area',
        },
        title: {
          text: 'Historic and Estimated Worldwide Population Distribution by Region',
        },
        subtitle: {
          text: 'Source: Wikipedia.org',
        },
        xAxis: {
          categories: ['1750', '1800', '1850', '1900', '1950', '1999', '2050'],
          tickmarkPlacement: 'on',
          title: {
            enabled: false,
          },
        },
        yAxis: {
          title: {
            text: 'Percent',
          },
        },
        tooltip: {
          pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.1f}%</b> ({point.y:,.0f} millions)<br/>',
          split: true,
        },
        plotOptions: {
          area: {
            stacking: 'percent',
            lineColor: '#ffffff',
            lineWidth: 1,
            marker: {
              lineWidth: 1,
              lineColor: '#ffffff',
            },
          },
        },
        series: [{
          name: 'Asia',
          data: [502, 635, 809, 947, 1402, 3634, 5268],
        }, {
          name: 'Africa',
          data: [106, 107, 111, 133, 221, 767, 1766],
        }, {
          name: 'Europe',
          data: [163, 203, 276, 408, 547, 729, 628],
        }, {
          name: 'America',
          data: [18, 31, 54, 156, 339, 818, 1201],
        }, {
          name: 'Oceania',
          data: [2, 2, 2, 6, 13, 30, 46],
        }],
      },
      optionsPie: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
        },
        title: {
          text: 'Browser market shares in January, 2018',
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.1f} %',
              style: {
                color: (VueHighCharts.theme && VueHighCharts.theme.contrastTextColor) || 'black',
              },
            },
          },
        },
        series: [{
          name: 'Brands',
          colorByPoint: true,
          data: [{
            name: 'Chrome',
            y: 61.41,
            sliced: true,
            selected: true,
          }, {
            name: 'Internet Explorer',
            y: 11.84,
          }, {
            name: 'Firefox',
            y: 10.85,
          }, {
            name: 'Edge',
            y: 4.67,
          }, {
            name: 'Safari',
            y: 4.18,
          }, {
            name: 'Sogou Explorer',
            y: 1.64,
          }, {
            name: 'Opera',
            y: 1.6,
          }, {
            name: 'QQ',
            y: 1.2,
          }, {
            name: 'Other',
            y: 2.61,
          }],
        }],
      },
      optionsDonut: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
        },
        title: {
          text: 'Browser<br>shares<br>2017',
          align: 'center',
          verticalAlign: 'middle',
          y: -10,
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: true,
              distance: -50,
              style: {
                fontWeight: 'bold',
                color: 'white',
              },
            },
          },
        },
        series: [{
          type: 'pie',
          name: 'Browser share',
          innerSize: '50%',
          data: [
            ['Chrome', 58.9],
            ['Firefox', 13.29],
            ['Internet Explorer', 13],
            ['Edge', 3.78],
            ['Safari', 3.42],
            {
              name: 'Other',
              y: 7.61,
              dataLabels: {
                enabled: false,
              },
            },
          ],
        }],
      },
      optionsSemiDonut: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
        },
        title: {
          text: 'Browser<br>shares<br>2017',
          align: 'center',
          verticalAlign: 'middle',
          y: 40,
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: true,
              distance: -50,
              style: {
                fontWeight: 'bold',
                color: 'white',
              },
            },
            startAngle: -90,
            endAngle: 90,
            center: ['50%', '75%'],
          },
        },
        series: [{
          type: 'pie',
          name: 'Browser share',
          innerSize: '50%',
          data: [
            ['Chrome', 58.9],
            ['Firefox', 13.29],
            ['Internet Explorer', 13],
            ['Edge', 3.78],
            ['Safari', 3.42],
            {
              name: 'Other',
              y: 7.61,
              dataLabels: {
                enabled: false,
              },
            },
          ],
        }],
      },
      optionsColumnStackedGrouped: {
        chart: {
          type: 'column',
        },

        title: {
          text: 'Total fruit consumtion, grouped by gender',
        },

        xAxis: {
          categories: ['Apples', 'Oranges', 'Pears', 'Grapes', 'Bananas'],
        },

        yAxis: {
          allowDecimals: false,
          min: 0,
          title: {
            text: 'Number of fruits',
          },
        },

        tooltip: {
          formatter() {
            return `<b>${this.x}</b><br/>${
              this.series.name}: ${this.y}<br/>` +
            `Total: ${this.point.stackTotal}`;
          },
        },

        plotOptions: {
          column: {
            stacking: 'normal',
          },
        },

        series: [{
          name: 'John',
          data: [5, 3, 4, 7, 2],
          stack: 'male',
        }, {
          name: 'Joe',
          data: [3, 4, 4, 2, 5],
          stack: 'male',
        }, {
          name: 'Jane',
          data: [2, 5, 6, 2, 1],
          stack: 'female',
        }, {
          name: 'Janet',
          data: [3, 0, 4, 4, 3],
          stack: 'female',
        }],
      },
      optionsBoxPlot: {
        chart: {
          type: 'boxplot',
        },

        title: {
          text: 'Highcharts Box Plot Example',
        },

        legend: {
          enabled: false,
        },

        xAxis: {
          categories: ['1', '2', '3', '4', '5'],
          title: {
            text: 'Experiment No.',
          },
        },

        yAxis: {
          title: {
            text: 'Observations',
          },
          plotLines: [{
            value: 932,
            color: 'red',
            width: 1,
            label: {
              text: 'Theoretical mean: 932',
              align: 'center',
              style: {
                color: 'gray',
              },
            },
          }],
        },

        series: [{
          name: 'Observations',
          data: [
            [760, 801, 848, 895, 965],
            [733, 853, 939, 980, 1080],
            [714, 762, 817, 870, 918],
            [724, 802, 806, 871, 950],
            [834, 836, 864, 882, 910],
          ],
          tooltip: {
            headerFormat: '<em>Experiment No {point.key}</em><br/>',
          },
        }, {
          name: 'Outlier',
          color: Highcharts.getOptions().colors[0],
          type: 'scatter',
          data: [ // x, y positions where 0 is the first category
            [0, 644],
            [4, 718],
            [4, 951],
            [4, 969],
          ],
          marker: {
            fillColor: 'white',
            lineWidth: 1,
            lineColor: Highcharts.getOptions().colors[0],
          },
          tooltip: {
            pointFormat: 'Observation: {point.y}',
          },
        }],
      },
      optionsPolygonSeries: {
        title: {
          text: 'Height vs Weight',
        },
        subtitle: {
          text: 'Polygon series in Highcharts',
        },
        xAxis: {
          gridLineWidth: 1,
          title: {
            enabled: true,
            text: 'Height (cm)',
          },
          startOnTick: true,
          endOnTick: true,
          showLastLabel: true,
        },
        yAxis: {
          title: {
            text: 'Weight (kg)',
          },
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
        },
        series: [{
          name: 'Target',
          type: 'polygon',
          data: [
            [153, 42], [149, 46], [149, 55], [152, 60], [159, 70], [170, 77], [180, 70],
            [180, 60], [173, 52], [166, 45],
          ],
          color: Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0.5).get(),
          enableMouseTracking: false,

        }, {
          name: 'Observations',
          type: 'scatter',
          color: Highcharts.getOptions().colors[1],
          data: [
            [161.2, 51.6], [167.5, 59.0], [159.5, 49.2], [157.0, 63.0], [155.8, 53.6],
            [170.0, 59.0], [159.1, 47.6], [166.0, 69.8], [176.2, 66.8], [160.2, 75.2],
            [172.5, 55.2], [170.9, 54.2], [172.9, 62.5], [153.4, 42.0], [160.0, 50.0],
            [147.2, 49.8], [168.2, 49.2], [175.0, 73.2], [157.0, 47.8], [167.6, 68.8],
            [159.5, 50.6], [175.0, 82.5], [166.8, 57.2], [176.5, 87.8], [170.2, 72.8],
            [174.0, 54.5], [173.0, 59.8], [179.9, 67.3], [170.5, 67.8], [160.0, 47.0],
            [154.4, 46.2], [162.0, 55.0], [176.5, 83.0], [160.0, 54.4], [152.0, 45.8],
            [162.1, 53.6], [170.0, 73.2], [160.2, 52.1], [161.3, 67.9], [166.4, 56.6],
            [168.9, 62.3], [163.8, 58.5], [167.6, 54.5], [160.0, 50.2], [161.3, 60.3],
            [167.6, 58.3], [165.1, 56.2], [160.0, 50.2], [170.0, 72.9], [157.5, 59.8],
            [167.6, 61.0], [160.7, 69.1], [163.2, 55.9], [152.4, 46.5], [157.5, 54.3],
            [168.3, 54.8], [180.3, 60.7], [165.5, 60.0], [165.0, 62.0], [164.5, 60.3],
            [156.0, 52.7], [160.0, 74.3], [163.0, 62.0], [165.7, 73.1], [161.0, 80.0],
            [162.0, 54.7], [166.0, 53.2], [174.0, 75.7], [172.7, 61.1], [167.6, 55.7],
            [151.1, 48.7], [164.5, 52.3], [163.5, 50.0], [152.0, 59.3], [169.0, 62.5],
            [164.0, 55.7], [161.2, 54.8], [155.0, 45.9], [170.0, 70.6], [176.2, 67.2],
            [170.0, 69.4], [162.5, 58.2], [170.3, 64.8], [164.1, 71.6], [169.5, 52.8],
            [163.2, 59.8], [154.5, 49.0], [159.8, 50.0], [173.2, 69.2], [170.0, 55.9],
            [161.4, 63.4], [169.0, 58.2], [166.2, 58.6], [159.4, 45.7], [162.5, 52.2],
            [159.0, 48.6], [162.8, 57.8], [159.0, 55.6], [179.8, 66.8], [162.9, 59.4],
            [161.0, 53.6], [151.1, 73.2], [168.2, 53.4], [168.9, 69.0], [173.2, 58.4],
            [171.8, 56.2], [178.0, 70.6], [164.3, 59.8], [163.0, 72.0], [168.5, 65.2],
            [166.8, 56.6], [172.7, 105.2], [163.5, 51.8], [169.4, 63.4], [167.8, 59.0],
            [159.5, 47.6], [167.6, 63.0], [161.2, 55.2], [160.0, 45.0], [163.2, 54.0],
            [162.2, 50.2], [161.3, 60.2], [149.5, 44.8], [157.5, 58.8], [163.2, 56.4],
            [172.7, 62.0], [155.0, 49.2], [156.5, 67.2], [164.0, 53.8], [160.9, 54.4],
            [162.8, 58.0], [167.0, 59.8], [160.0, 54.8], [160.0, 43.2], [168.9, 60.5],
            [158.2, 46.4], [156.0, 64.4], [160.0, 48.8], [167.1, 62.2], [158.0, 55.5],
            [167.6, 57.8], [156.0, 54.6], [162.1, 59.2], [173.4, 52.7], [159.8, 53.2],
            [170.5, 64.5], [159.2, 51.8], [157.5, 56.0], [161.3, 63.6], [162.6, 63.2],
            [160.0, 59.5], [168.9, 56.8], [165.1, 64.1], [162.6, 50.0], [165.1, 72.3],
            [166.4, 55.0], [160.0, 55.9], [152.4, 60.4], [170.2, 69.1], [162.6, 84.5],
            [170.2, 55.9], [158.8, 55.5], [172.7, 69.5], [167.6, 76.4], [162.6, 61.4],
            [167.6, 65.9], [156.2, 58.6], [175.2, 66.8], [172.1, 56.6], [162.6, 58.6],
            [160.0, 55.9], [165.1, 59.1], [182.9, 81.8], [166.4, 70.7], [165.1, 56.8],
            [177.8, 60.0], [165.1, 58.2], [175.3, 72.7], [154.9, 54.1], [158.8, 49.1],
            [172.7, 75.9], [168.9, 55.0], [161.3, 57.3], [167.6, 55.0], [165.1, 65.5],
            [175.3, 65.5], [157.5, 48.6], [163.8, 58.6], [167.6, 63.6], [165.1, 55.2],
            [165.1, 62.7], [168.9, 56.6], [162.6, 53.9], [164.5, 63.2], [176.5, 73.6],
            [168.9, 62.0], [175.3, 63.6], [159.4, 53.2], [160.0, 53.4], [170.2, 55.0],
            [162.6, 70.5], [167.6, 54.5], [162.6, 54.5], [160.7, 55.9], [160.0, 59.0],
            [157.5, 63.6], [162.6, 54.5], [152.4, 47.3], [170.2, 67.7], [165.1, 80.9],
            [172.7, 70.5], [165.1, 60.9], [170.2, 63.6], [170.2, 54.5], [170.2, 59.1],
            [161.3, 70.5], [167.6, 52.7], [167.6, 62.7], [165.1, 86.3], [162.6, 66.4],
            [152.4, 67.3], [168.9, 63.0], [170.2, 73.6], [175.2, 62.3], [175.2, 57.7],
            [160.0, 55.4], [165.1, 104.1], [174.0, 55.5], [170.2, 77.3], [160.0, 80.5],
            [167.6, 64.5], [167.6, 72.3], [167.6, 61.4], [154.9, 58.2], [162.6, 81.8],
            [175.3, 63.6], [171.4, 53.4], [157.5, 54.5], [165.1, 53.6], [160.0, 60.0],
            [174.0, 73.6], [162.6, 61.4], [174.0, 55.5], [162.6, 63.6], [161.3, 60.9],
            [156.2, 60.0], [149.9, 46.8], [169.5, 57.3], [160.0, 64.1], [175.3, 63.6],
            [169.5, 67.3], [160.0, 75.5], [172.7, 68.2], [162.6, 61.4], [157.5, 76.8],
            [176.5, 71.8], [164.4, 55.5], [160.7, 48.6], [174.0, 66.4], [163.8, 67.3],
          ],
        }],
        tooltip: {
          headerFormat: '<b>{series.name}</b><br>',
          pointFormat: '{point.x} cm, {point.y} kg',
        },
      },
      optionsGeneralDrawing: {
        chart: {
          backgroundColor: 'white',
          events: {
            load() {
              // Draw the flow chart
              const ren = this.renderer;
              const { colors } = Highcharts.getOptions().colors;
              const rightArrow = ['M', 0, 0, 'L', 100, 0, 'L', 95, 5, 'M', 100, 0, 'L', 95, -5];
              const leftArrow = ['M', 100, 0, 'L', 0, 0, 'L', 5, 5, 'M', 0, 0, 'L', 5, -5];
              // Separator, client from service
              ren.path(['M', 120, 40, 'L', 120, 330])
                .attr({
                  'stroke-width': 2,
                  stroke: 'silver',
                  dashstyle: 'dash',
                })
                .add();
              // Separator, CLI from service
              ren.path(['M', 420, 40, 'L', 420, 330])
                .attr({
                  'stroke-width': 2,
                  stroke: 'silver',
                  dashstyle: 'dash',
                })
                .add();
              // Headers
              ren.label('Web client', 20, 40)
                .css({
                  fontWeight: 'bold',
                })
                .add();
              ren.label('Web service / CLI', 220, 40)
                .css({
                  fontWeight: 'bold',
                })
                .add();
              ren.label('Command line client', 440, 40)
                .css({
                  fontWeight: 'bold',
                })
                .add();
              // SaaS client label
              ren.label('SaaS client<br/>(browser or<br/>script)', 10, 82)
                .attr({
                  fill: colors[0],
                  stroke: 'white',
                  'stroke-width': 2,
                  padding: 5,
                  r: 5,
                })
                .css({
                  color: 'white',
                })
                .add()
                .shadow(true);
              // Arrow from SaaS client to Phantom JS
              ren.path(rightArrow)
                .attr({
                  'stroke-width': 2,
                  stroke: colors[3],
                })
                .translate(95, 95)
                .add();
              ren.label('POST options in JSON', 90, 75)
                .css({
                  fontSize: '10px',
                  color: colors[3],
                })
                .add();
              ren.label('PhantomJS', 210, 82)
                .attr({
                  r: 5,
                  width: 100,
                  fill: colors[1],
                })
                .css({
                  color: 'white',
                  fontWeight: 'bold',
                })
                .add();
              // Arrow from Phantom JS to Batik
              ren.path(['M', 250, 110, 'L', 250, 185, 'L', 245, 180, 'M', 250, 185, 'L', 255, 180])
                .attr({
                  'stroke-width': 2,
                  stroke: colors[3],
                })
                .add();
              ren.label('SVG', 255, 120)
                .css({
                  color: colors[3],
                  fontSize: '10px',
                })
                .add();
              ren.label('Batik', 210, 200)
                .attr({
                  r: 5,
                  width: 100,
                  fill: colors[1],
                })
                .css({
                  color: 'white',
                  fontWeight: 'bold',
                })
                .add();
              // Arrow from Batik to SaaS client
              ren.path([
                'M', 235, 185,
                'L', 235, 155,
                'C', 235, 130, 235, 130, 215, 130,
                'L', 95, 130,
                'L', 100, 125,
                'M', 95, 130,
                'L', 100, 135,
              ])
                .attr({
                  'stroke-width': 2,
                  stroke: colors[3],
                })
                .add();
              ren.label('Rasterized image', 100, 110)
                .css({
                  color: colors[3],
                  fontSize: '10px',
                })
                .add();
              // Browser label
              ren.label('Browser<br/>running<br/>Highcharts', 10, 180)
                .attr({
                  fill: colors[0],
                  stroke: 'white',
                  'stroke-width': 2,
                  padding: 5,
                  r: 5,
                })
                .css({
                  color: 'white',
                  width: '100px',
                })
                .add()
                .shadow(true);

              // Arrow from Browser to Batik
              ren.path(rightArrow)
                .attr({
                  'stroke-width': 2,
                  stroke: colors[1],
                })
                .translate(95, 205)
                .add();
              ren.label('POST SVG', 110, 185)
                .css({
                  color: colors[1],
                  fontSize: '10px',
                })
                .add();
              // Arrow from Batik to Browser
              ren.path(leftArrow)
                .attr({
                  'stroke-width': 2,
                  stroke: colors[1],
                })
                .translate(95, 215)
                .add();
              ren.label('Rasterized image', 100, 215)
                .css({
                  color: colors[1],
                  fontSize: '10px',
                })
                .add();
              // Script label
              ren.label('Script', 450, 82)
                .attr({
                  fill: colors[2],
                  stroke: 'white',
                  'stroke-width': 2,
                  padding: 5,
                  r: 5,
                })
                .css({
                  color: 'white',
                  width: '100px',
                })
                .add()
                .shadow(true);
              // Arrow from Script to PhantomJS
              ren.path(leftArrow)
                .attr({
                  'stroke-width': 2,
                  stroke: colors[2],
                })
                .translate(330, 90)
                .add();
              ren.label('Command', 340, 70)
                .css({
                  color: colors[2],
                  fontSize: '10px',
                })
                .add();
              // Arrow from PhantomJS to Script
              ren.path(rightArrow)
                .attr({
                  'stroke-width': 2,
                  stroke: colors[2],
                })
                .translate(330, 100)
                .add();
              ren.label('Rasterized image', 330, 100)
                .css({
                  color: colors[2],
                  fontSize: '10px',
                })
                .add();
            },
          },
        },
        title: {
          text: 'Highcharts export server overview',
          style: {
            color: 'black',
          },
        },
      },
      optionsAddPoint: {
        chart: {
          type: 'scatter',
          margin: [70, 50, 60, 80],
          events: {
            click(e) {
              const x = Math.round(e.xAxis[0].value);
              const y = Math.round(e.yAxis[0].value);
              const series = this.series[0];

              series.addPoint([x, y]);
            },
          },
        },
        title: {
          text: 'User supplied data',
        },
        subtitle: {
          text: 'Click the plot area to add a point. Click a point to remove it.',
        },
        xAxis: {
          gridLineWidth: 1,
          minPadding: 0.2,
          maxPadding: 0.2,
          maxZoom: 60,
        },
        yAxis: {
          title: {
            text: 'Value',
          },
          minPadding: 0.2,
          maxPadding: 0.2,
          maxZoom: 60,
          plotLines: [{
            value: 0,
            width: 1,
            color: '#808080',
          }],
        },
        legend: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
        plotOptions: {
          series: {
            lineWidth: 1,
            point: {
              events: {
                click() {
                  if (this.series.data.length > 1) {
                    this.remove();
                  }
                },
              },
            },
          },
        },
        series: [{
          data: [[20, 20], [80, 80]],
        }],
      },
      optionsCombination1: {
        title: {
          text: 'Combination chart',
        },
        xAxis: {
          categories: ['Apples', 'Oranges', 'Pears', 'Bananas', 'Plums'],
        },
        labels: {
          items: [{
            html: 'Total fruit consumption',
            style: {
              left: '50px',
              top: '18px',
              // color: (VueHighCharts.theme && VueHighCharts.theme.textColor) || 'black'
            },
          }],
        },
        series: [{
          type: 'column',
          name: 'Jane',
          data: [3, 2, 1, 3, 4],
        }, {
          type: 'column',
          name: 'John',
          data: [2, 3, 5, 7, 6],
        }, {
          type: 'column',
          name: 'Joe',
          data: [4, 3, 3, 9, 0],
        }, {
          type: 'spline',
          name: 'Average',
          data: [3, 2.67, 3, 6.33, 3.33],
          marker: {
            lineWidth: 2,
            // lineColor: VueHighCharts.getOptions().colors[3],
            fillColor: 'white',
          },
        }, {
          type: 'pie',
          name: 'Total consumption',
          data: [{
            name: 'Jane',
            y: 13,
            // color: VueHighCharts.getOptions().colors[0] // Jane's color
          }, {
            name: 'John',
            y: 23,
            // color: VueHighCharts.getOptions().colors[1] // John's color
          }, {
            name: 'Joe',
            y: 19,
            // color: VueHighCharts.getOptions().colors[2] // Joe's color
          }],
          center: [100, 80],
          size: 100,
          showInLegend: false,
          dataLabels: {
            enabled: false,
          },
        }],
      },
      optionsCombination2: {
        chart: {
          zoomType: 'xy',
        },
        title: {
          text: 'Average Monthly Temperature and Rainfall in Tokyo',
        },
        subtitle: {
          text: 'Source: WorldClimate.com',
        },
        xAxis: [{
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          crosshair: true,
        }],
        yAxis: [{ // Primary yAxis
          labels: {
            format: '{value}°C',
            style: {
              color: '#000000',
            },
          },
          title: {
            text: 'Temperature',
            style: {
              color: '#222',
            },
          },
        }, { // Secondary yAxis
          title: {
            text: 'Rainfall',
            style: {
              color: '#222',
            },
          },
          labels: {
            format: '{value} mm',
            style: {
              // color: '#222'
            },
          },
          opposite: true,
        }],
        tooltip: {
          shared: true,
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          x: 120,
          verticalAlign: 'top',
          y: 100,
          floating: true,
        },
        series: [{
          name: 'Rainfall',
          type: 'column',
          yAxis: 1,
          data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4],
          tooltip: {
            valueSuffix: ' mm',
          },

        }, {
          name: 'Temperature',
          type: 'spline',
          color: 'red',
          data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6],
          tooltip: {
            valueSuffix: '°C',
          },
        }],
      },
      optionsCombination3: {
        chart: {
          zoomType: 'xy',
        },
        title: {
          text: 'Average Monthly Weather Data for Tokyo',
        },
        subtitle: {
          text: 'Source: WorldClimate.com',
        },
        xAxis: [{
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          crosshair: true,
        }],
        yAxis: [{ // Primary yAxis
          labels: {
            format: '{value}°C',
            style: {
              // color: Highcharts.getOptions().colors[2]
            },
          },
          title: {
            text: 'Temperature',
            style: {
              // color: Highcharts.getOptions().colors[2]
            },
          },
          opposite: true,

        }, { // Secondary yAxis
          gridLineWidth: 0,
          title: {
            text: 'Rainfall',
            style: {
              // color: Highcharts.getOptions().colors[0]
            },
          },
          labels: {
            format: '{value} mm',
            style: {
              // color: Highcharts.getOptions().colors[0]
            },
          },

        }, { // Tertiary yAxis
          gridLineWidth: 0,
          title: {
            text: 'Sea-Level Pressure',
            style: {
              // color: Highcharts.getOptions().colors[1]
            },
          },
          labels: {
            format: '{value} mb',
            style: {
              // color: Highcharts.getOptions().colors[1]
            },
          },
          opposite: true,
        }],
        tooltip: {
          shared: true,
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          x: 80,
          verticalAlign: 'top',
          y: 55,
          floating: true,
          backgroundColor: '#FFFFFF',
        },
        series: [{
          name: 'Rainfall',
          type: 'column',
          yAxis: 1,
          data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4],
          tooltip: {
            valueSuffix: ' mm',
          },

        }, {
          name: 'Sea-Level Pressure',
          type: 'spline',
          yAxis: 2,
          data: [1016, 1016, 1015.9, 1015.5, 1012.3, 1009.5,
            1009.6, 1010.2, 1013.1, 1016.9, 1018.2, 1016.7,
          ],
          marker: {
            enabled: false,
          },
          dashStyle: 'shortdot',
          tooltip: {
            valueSuffix: ' mb',
          },

        }, {
          name: 'Temperature',
          type: 'spline',
          data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6],
          tooltip: {
            valueSuffix: ' °C',
          },
        }],
      },
      optionsCombination4: {
        xAxis: {
          min: -0.5,
          max: 5.5,
        },
        yAxis: {
          min: 0,
        },
        title: {
          text: 'Scatter plot with regression line',
        },
        series: [{
          type: 'line',
          name: 'Regression Line',
          data: [[0, 1.11], [5, 4.51]],
          marker: {
            enabled: false,
          },
          states: {
            hover: {
              lineWidth: 0,
            },
          },
          enableMouseTracking: false,
        }, {
          type: 'scatter',
          name: 'Observations',
          data: [1, 1.5, 2.8, 3.5, 3.9, 4.2],
          marker: {
            radius: 4,
          },
        }],
      },
    };
  },
};
</script>

